__turbopack_context__.v({
  "accordionContent": "accordion-module-scss-module__Nwx1QG__accordionContent",
  "accordionHeader": "accordion-module-scss-module__Nwx1QG__accordionHeader",
  "accordionIcon": "accordion-module-scss-module__Nwx1QG__accordionIcon",
  "accordionIconChevron": "accordion-module-scss-module__Nwx1QG__accordionIconChevron",
  "accordionIconClosed": "accordion-module-scss-module__Nwx1QG__accordionIconClosed",
  "accordionIconOpen": "accordion-module-scss-module__Nwx1QG__accordionIconOpen",
  "accordionItem": "accordion-module-scss-module__Nwx1QG__accordionItem",
  "accordionSlideOverwrite": "accordion-module-scss-module__Nwx1QG__accordionSlideOverwrite",
  "accordionTrigger": "accordion-module-scss-module__Nwx1QG__accordionTrigger",
  "accordionTriggerChildren": "accordion-module-scss-module__Nwx1QG__accordionTriggerChildren",
  "contentMobileSpacer": "accordion-module-scss-module__Nwx1QG__contentMobileSpacer",
  "fadeIn": "accordion-module-scss-module__Nwx1QG__fadeIn",
  "fadeOut": "accordion-module-scss-module__Nwx1QG__fadeOut",
  "scaleIn": "accordion-module-scss-module__Nwx1QG__scaleIn",
  "scaleOut": "accordion-module-scss-module__Nwx1QG__scaleOut",
  "slideDown": "accordion-module-scss-module__Nwx1QG__slideDown",
  "slideUp": "accordion-module-scss-module__Nwx1QG__slideUp",
  "zoomIn": "accordion-module-scss-module__Nwx1QG__zoomIn",
  "zoomOut": "accordion-module-scss-module__Nwx1QG__zoomOut",
});
